// The single A/B-variant seam. Every tracking event reads the funnel variant
// through getFunnelVariant(); it is the ONLY place window.AB_VARIANT is read.
// The experimentation milestone (GrowthBook) swaps this implementation (e.g. read
// a cookie / data-variant) without touching any call site. Resolved per call so an
// external A/B tool can inject the value after our bundle has loaded.
export const DEFAULT_FUNNEL_VARIANT = 'chatbot-v2'

const MAX_LEN = 32

export function getFunnelVariant(): string {
  if (typeof window === 'undefined') return DEFAULT_FUNNEL_VARIANT
  const v = (window as unknown as { AB_VARIANT?: unknown }).AB_VARIANT
  if (typeof v === 'string' && v.length > 0 && v.length <= MAX_LEN) return v
  return DEFAULT_FUNNEL_VARIANT
}

export function useFunnelVariant() {
  return { getFunnelVariant }
}
